import { forwardRef, PropsWithChildren } from 'react';

export const ModalFullScreenFooter = forwardRef<HTMLDivElement, PropsWithChildren>((props, ref) => (
  <div
    className="flex items-center justify-between border-t border-border-primary py-2 pr-6 pl-6"
    {...props}
    ref={ref}
  />
));

ModalFullScreenFooter.displayName = 'ModalFullscreenFooter';
